module.exports = __webpack_public_path__ + "static/two-people-chatting-c360ae9a24d35488cc7a6d3422328673.svg";